import { User } from "../../../common/models";

export const FMS_CHAT_GROUP = "juniper.self-serve.fms-chat";
export const SELF_SERVE_ADMIN_GROUP = "juniper.self-serve.admin";

export const userIsAuthorized = (user: User | undefined, requiredGroups: string[]): boolean => {
    if (!user || !user.rampartGroups) {
        return false;
    }
    
    return requiredGroups.every((group: string) => {
        return user!.rampartGroups!.includes(group);
    });
}